import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/faq/metatrader5.svg")